var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "search-input" },
        [
          _c(
            "v-icon",
            {
              on: {
                click: function($event) {
                  return _vm.$emit("handleIconClick")
                }
              }
            },
            [_vm._v("mdi-arrow-left")]
          ),
          _vm._v(" "),
          _c("v-text-field", {
            staticClass: "search-bar-styling",
            attrs: { placeholder: "Search Profile", solo: "" },
            on: {
              keydown: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.$emit("handleOnEnter")
              },
              input: function(val) {
                return _vm.$emit("getInputValue", val)
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm._t("search-container-body")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }